package com.htmlagent.site.i18n

// Generated from i18n/strings.json. Do not edit: edit the JSON and rebuild.

/** The texts of the activity area. */
interface ActivityStrings {
    val thinking: String

    val planning: String

    val writingPage: String

    val stopping: String

    val working: String

    val ready: String

    val consultingInstructions: String

    fun consultingSkill(name: String): String

    val checkingPage: String

    val reviewingDesign: String

    val correcting: String

    val saving: String

    val searchingPhotos: String

    fun searchingNamedPhotos(query: String): String

    val readingSection: String

    fun readingNamedSection(name: String): String

    val editingSection: String

    fun editingNamedSection(name: String): String

    fun sectionLabel(id: String): String

    val lookingAtPage: String
}

/** The activity area in Spanish. */
internal object SpanishActivityStrings : ActivityStrings {
    override val thinking: String = "Pensando"

    override val planning: String = "Planificando"

    override val writingPage: String = "Escribiendo la página"

    override val stopping: String = "Parando…"

    override val working: String = "Trabajando"

    override val ready: String = "Lista"

    override val consultingInstructions: String = "Consultando sus instrucciones"

    override fun consultingSkill(name: String): String = "Consultando $name"

    override val checkingPage: String = "Comprobando la página en el navegador"

    override val reviewingDesign: String = "Revisando el diseño con capturas"

    override val correcting: String = "Corrigiendo lo que encontró la revisión"

    override val saving: String = "Guardando la versión"

    override val searchingPhotos: String = "Buscando fotos"

    override fun searchingNamedPhotos(query: String): String = "Buscando fotos: $query"

    override val readingSection: String = "Leyendo una sección"

    override fun readingNamedSection(name: String): String = "Leyendo la sección $name"

    override val editingSection: String = "Editando una sección"

    override fun editingNamedSection(name: String): String = "Editando la sección $name"

    override fun sectionLabel(id: String): String =
        mapOf(
        "nav" to "Navegación",
        "navbar" to "Navegación",
        "header" to "Cabecera",
        "cabecera" to "Cabecera",
        "hero" to "Portada",
        "portada" to "Portada",
        "features" to "Características",
        "caracteristicas" to "Características",
        "services" to "Servicios",
        "servicios" to "Servicios",
        "about" to "Quiénes somos",
        "sobre-nosotros" to "Quiénes somos",
        "gallery" to "Galería",
        "galeria" to "Galería",
        "pricing" to "Precios",
        "precios" to "Precios",
        "testimonials" to "Testimonios",
        "testimonios" to "Testimonios",
        "faq" to "Preguntas frecuentes",
        "contact" to "Contacto",
        "contacto" to "Contacto",
        "cta" to "Llamada a la acción",
        "footer" to "Pie",
        "pie" to "Pie",
        "styles" to "Estilos",
        "estilos" to "Estilos",
        "behavior" to "Interacción",
        "behaviour" to "Interacción",
        "comportamiento" to "Interacción",
        "script" to "Interacción",
        "hours" to "Horarios",
        "horarios" to "Horarios",
        "horario" to "Horarios",
        "schedule" to "Horarios",
        "opening" to "Horarios",
        "closing" to "Cierre",
        "cierre" to "Cierre",
        "menu" to "Carta",
        "carta" to "Carta",
        "location" to "Cómo llegar",
        "ubicacion" to "Cómo llegar",
        "map" to "Mapa",
        "mapa" to "Mapa",
        "booking" to "Reservas",
        "reservas" to "Reservas",
        "reserva" to "Reservas",
        "team" to "Equipo",
        "equipo" to "Equipo",
        "products" to "Productos",
        "productos" to "Productos",
        "catalog" to "Catálogo",
        "catalogo" to "Catálogo",
        "work" to "Trabajos",
        "trabajos" to "Trabajos",
        "projects" to "Proyectos",
        "proyectos" to "Proyectos",
        "program" to "Programa",
        "programa" to "Programa",
        "tickets" to "Entradas",
        "entradas" to "Entradas",
        "story" to "Historia",
        "historia" to "Historia",
        "offer" to "Oferta",
        "oferta" to "Oferta",
        "benefits" to "Ventajas",
        "ventajas" to "Ventajas",
        "steps" to "Pasos",
        "pasos" to "Pasos",
        "signup" to "Alta",
        "alta" to "Alta",
        "newsletter" to "Boletín",
        "boletin" to "Boletín",
        )[id] ?: humanizeSectionId(id)

    override val lookingAtPage: String = "Mirando la página"
}

/** The activity area in English. */
internal object EnglishActivityStrings : ActivityStrings {
    override val thinking: String = "Thinking"

    override val planning: String = "Planning"

    override val writingPage: String = "Writing the page"

    override val stopping: String = "Stopping…"

    override val working: String = "Working"

    override val ready: String = "Ready"

    override val consultingInstructions: String = "Reading its instructions"

    override fun consultingSkill(name: String): String = "Reading $name"

    override val checkingPage: String = "Checking the page in a browser"

    override val reviewingDesign: String = "Reviewing the design from screenshots"

    override val correcting: String = "Fixing what the check found"

    override val saving: String = "Saving the version"

    override val searchingPhotos: String = "Looking for photos"

    override fun searchingNamedPhotos(query: String): String = "Looking for photos: $query"

    override val readingSection: String = "Reading a section"

    override fun readingNamedSection(name: String): String = "Reading the $name section"

    override val editingSection: String = "Editing a section"

    override fun editingNamedSection(name: String): String = "Editing the $name section"

    override fun sectionLabel(id: String): String =
        mapOf(
        "nav" to "Navigation",
        "navbar" to "Navigation",
        "header" to "Header",
        "cabecera" to "Header",
        "hero" to "Hero",
        "portada" to "Hero",
        "features" to "Features",
        "caracteristicas" to "Features",
        "services" to "Services",
        "servicios" to "Services",
        "about" to "About us",
        "sobre-nosotros" to "About us",
        "gallery" to "Gallery",
        "galeria" to "Gallery",
        "pricing" to "Pricing",
        "precios" to "Pricing",
        "testimonials" to "Testimonials",
        "testimonios" to "Testimonials",
        "faq" to "FAQ",
        "contact" to "Contact",
        "contacto" to "Contact",
        "cta" to "Call to action",
        "footer" to "Footer",
        "pie" to "Footer",
        "styles" to "Styles",
        "estilos" to "Styles",
        "behavior" to "Interaction",
        "behaviour" to "Interaction",
        "comportamiento" to "Interaction",
        "script" to "Interaction",
        "hours" to "Opening hours",
        "horarios" to "Opening hours",
        "horario" to "Opening hours",
        "schedule" to "Opening hours",
        "opening" to "Opening hours",
        "closing" to "Closing",
        "cierre" to "Closing",
        "menu" to "Menu",
        "carta" to "Menu",
        "location" to "Getting there",
        "ubicacion" to "Getting there",
        "map" to "Map",
        "mapa" to "Map",
        "booking" to "Booking",
        "reservas" to "Booking",
        "reserva" to "Booking",
        "team" to "Team",
        "equipo" to "Team",
        "products" to "Products",
        "productos" to "Products",
        "catalog" to "Catalogue",
        "catalogo" to "Catalogue",
        "work" to "Work",
        "trabajos" to "Work",
        "projects" to "Projects",
        "proyectos" to "Projects",
        "program" to "Programme",
        "programa" to "Programme",
        "tickets" to "Tickets",
        "entradas" to "Tickets",
        "story" to "Story",
        "historia" to "Story",
        "offer" to "Offer",
        "oferta" to "Offer",
        "benefits" to "Benefits",
        "ventajas" to "Benefits",
        "steps" to "Steps",
        "pasos" to "Steps",
        "signup" to "Sign up",
        "alta" to "Sign up",
        "newsletter" to "Newsletter",
        "boletin" to "Newsletter",
        )[id] ?: humanizeSectionId(id)

    override val lookingAtPage: String = "Looking at the page"
}
